(function(){
    'use strict';

    angular
       .module('appback')
       .factory('MicrobiologiaService', MicrobiologiaService);

   MicrobiologiaService.$inject = ['$http', '$q'];

   function MicrobiologiaService($http, $q){

       var service= {
          getLecturasByPeticionIdAnaliticaId:getLecturasByPeticionIdAnaliticaId,
          guardarLectura:guardarLectura,
          finalizarLecturaPeticionAnalitica:finalizarLecturaPeticionAnalitica,
          reabrirLectura:reabrirLectura,
          guardarLecturaEditada:guardarLecturaEditada,
          getNextAntibiogramaMalditofID:getNextAntibiogramaMalditofID,
          changeEstadoTarea:changeEstadoTarea,
          getPlacasMalditof:getPlacasMalditof,
          getMalditofsPend:getMalditofsPend,
          guardarPlaca:guardarPlaca,
          generarFichero:generarFichero,
          cerrarPlaca:cerrarPlaca,
          addNewPlaca:addNewPlaca
       };

       return service;

       function cerrarPlaca(placa, callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({ 
                placa:JSON.stringify(placa)
            });
            $http.post('/backend/microbiologia/cerrarplaca',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }        
        }

        function generarFichero(placa, callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({ 
                placa:JSON.stringify(placa)
            });
            $http.post('/backend/microbiologia/generarficheroplaca',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }        
        }


        function addNewPlaca(callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({ 
            });
            $http.post('/backend/microbiologia/addnewplaca',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }        
        }

       function guardarPlaca(placa, callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({ 
                placa:JSON.stringify(placa)
            });
            $http.post('/backend/microbiologia/guardarplaca',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }        
       }

       function getPlacasMalditof(fecha, callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/microbiologia/getplacasmalditof', {params:{ fecha: fecha}}, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

       function getMalditofsPend(buscador,user,placas,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({ 
                buscador:buscador,
                user:user,
                placas:JSON.stringify(placas)
            });

            $http.post('/backend/microbiologia/getmalditofspend', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }


       function getNextAntibiogramaMalditofID(peticion_id, analitica_id,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/microbiologia/getnextantibiogramamalditofid', {  params : { peticion_id : peticion_id, analitica_id : analitica_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

       function getLecturasByPeticionIdAnaliticaId(peticion_id,analitica_id,resembrado_id,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/microbiologia/getlecturas', {  params : {peticion_id : peticion_id, analitica_id : analitica_id, resembrado_id : resembrado_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function guardarLectura(peticion_id, analitica_id, resembrado_id, lectura,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({ 
                peticion_id:peticion_id,
                analitica_id:analitica_id,
                resembrado_id:resembrado_id,
                lectura:JSON.stringify(lectura)
            });
            $http.post('/backend/microbiologia/guardarlectura',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function finalizarLecturaPeticionAnalitica(peticion_id,analitica_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({ 
                peticion_id:peticion_id,
                analitica_id:analitica_id
            });
            $http.post('/backend/microbiologia/finalizarlectura',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function reabrirLectura(peticion_id,analitica_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({ 
                peticion_id:peticion_id,
                analitica_id:analitica_id
            });
            $http.post('/backend/microbiologia/reabrirlectura',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function guardarLecturaEditada(peticion_id, analitica_id, resembrado_id, lectura_id, lectura,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                peticion_id:peticion_id,
                analitica_id:analitica_id,
                resembrado_id:resembrado_id,
                lectura_id:lectura_id, 
                lectura:JSON.stringify(lectura)
            });
            $http.post('/backend/microbiologia/guardarlecturaeditada',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function changeEstadoTarea(aislado_id, tarea, callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                aislado_id:aislado_id,
                tarea:tarea
            });
            $http.post('/backend/microbiologia/changeestadotarea',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
      
    }
})();